/* ------------------- IMPORTS */
import styled from '@emotion/styled'
import { Box } from 'components'
import { AppStore } from 'utils'

/* ------------------- TYPES  */

/* ------------------- INTERFACES  */

interface Props {
  isActive: boolean
  onChange: (value: boolean) => void
}

export const TogglerApply = ({ isActive, onChange }: Props) => {
  /* ----------------- STATE  */

  /* ----------------- REF  */

  /* ----------------- ZUSTAND  */

  /* ----------------- VARIABLES  */

  /* ----------------- METHODS  */

  /* ----------------- API CALL  */

  /* ----------------- USEEFFECT  */

  return (
    <TogglerContainer isActive={isActive} onClick={() => onChange(!isActive)}>
      <Ball isActive={isActive} />
    </TogglerContainer>
  )
}

const TogglerContainer = styled(Box)<{ isActive: boolean }>`
  cursor: pointer;
  height: 20px;
  width: 36px;
  border-radius: 11.79px;
  position: relative;
  border: 1px solid ${({ isActive }) => (isActive ? AppStore.theme.o.on_primary_container : AppStore.theme.o.grey)};
  background-color: ${({ isActive }) => (isActive ? AppStore.theme.o.primary_container : AppStore.theme.o.lightGrey)};
`

const Ball = styled(Box)<{ isActive: boolean }>`
  height: 16px;
  width: 16px;
  border-radius: 50%;
  border: 1px solid ${() => AppStore.theme.o.lightGrey};
  position: absolute;
  background-color: ${({ isActive }) => (isActive ? AppStore.theme.o.on_primary_container : AppStore.theme.o.black)};

  top: 50%;
  transform: translateY(-50%);

  ${({ isActive }) =>
    isActive
      ? `
          right: 1.5px;
      `
      : `
          left: 2px;
      `}
`
